'use client';
import {
  ProductCardImage,
  type ProductCardImageProps,
} from '@curology/ui-components-web/react/Card/ProductCard/ProductCardImage';
import React from 'react';
import Slider from 'react-slick';

import './styles.css';

interface Image {
  alt: string;
  src: string;
}

const Carousel = ({
  aspectRatio,
  autoplay = true,
  autoplaySpeed,
  images,
}: {
  aspectRatio?: ProductCardImageProps['aspectRatio'];
  autoplay?: boolean;
  autoplaySpeed?: number;
  images: Image[];
}) => {
  const containerAspectRatio = aspectRatio?.includes(':')
    ? aspectRatio.replace(':', ' / ')
    : '1 / 1';

  return (
    <div className="carousel" style={{ aspectRatio: containerAspectRatio }}>
      <Slider
        accessibility={true}
        arrows={false}
        autoplay={autoplay}
        autoplaySpeed={autoplaySpeed || 6000}
        dots={true}
        draggable={true}
        infinite={true}
        speed={1000}
      >
        {images.map((image) => {
          return (
            <ProductCardImage
              alt={image.alt}
              aspectRatio={aspectRatio}
              className="cur-cursor-default"
              key={image.src}
              onClick={(event) => event.stopPropagation()}
              src={image.src}
            />
          );
        })}
      </Slider>
    </div>
  );
};

export default Carousel;
